// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider[data-v-67d57de1]{margin:8px 0}.block-delivery-fee-per-order[data-v-67d57de1]{display:flex;align-items:stretch;gap:10px}.block-delivery-fee-per-order>div[data-v-67d57de1]{flex:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
